import { render, staticRenderFns } from "./VSticky.vue?vue&type=template&id=18901b31&scoped=true&"
import script from "./VSticky.vue?vue&type=script&lang=js&"
export * from "./VSticky.vue?vue&type=script&lang=js&"
import style0 from "./VSticky.vue?vue&type=style&index=0&id=18901b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18901b31",
  null
  
)

export default component.exports